import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InsurerState, insurerFeatureKey } from './insurer.reducer';

export const selectInsurerState = createFeatureSelector<InsurerState>(insurerFeatureKey);
export const getInsurerList = createSelector(selectInsurerState, state => state.insurerList);
